/**
 * Test IDs for QA automation.
 */
export const testIds = {
  orgDataTransferSourceStage: "org-data-transfer-source-stage",
  orgDataTransferSourceStageOption: "org-data-transfer-source-stage-option",
  orgDataTransferSourceOrganizationPicker: "org-data-transfer-source-organization-picker",
  orgDataTransferTargetStage: "org-data-transfer-target-stage",
  orgDataTransferTargetStageOption: "org-data-transfer-target-stage-option",
  orgDataTransferTargetOrganizationPicker: "org-data-transfer-target-organization-picker",
  orgDataTransferDeleteExistingData: "org-data-transfer-delete-existing-data",
  orgDataTransferStartTransfer: "org-data-transfer-start-transfer",
  orgDataTransferCancel: "org-data-transfer-cancel",
  orgDataTransferConfirmTransfer: "org-data-transfer-confirm-transfer",
} as const;
